module.exports = __webpack_public_path__ + "static/media/wrong.b912d694.mp3";